import React from 'react'
import { connect } from 'react-redux'

import Trend from 'react-trend'
import { Link } from 'react-router-dom';

import Campaigns from './Campaigns'
import Segments from './Segments'

import { randomDataArr, getRandomInt, shuffle } from '../helpers'

const data = randomDataArr(12);

const EventsTimeline = ({ events }) => {
  // const pos = [20, 30, 40, 50, 60, 70, 80, 90];
  const p = [...Array(90)].map((item,i) => i);
  const pos = shuffle(p).slice(0, events.length);

  return (
    <div className="events-timeline">
      <div className="graph">
        <Trend
          className="events-timeline__graph"
          smooth
          autoDraw
          autoDrawDuration={3000}
          autoDrawEasing="ease-out"
          data={data}
          gradient={['#00c6ff', '#F0F', '#FF0']}
          radius={10}
          strokeWidth={1}
          strokeLinecap={'butt'}
          padding={0}
        />
        <div className="graph__y">
          <div className="graph__label">5000</div>
          <div className="graph__label">10000</div>
          <div className="graph__label">15000</div>
          <div className="graph__label">20000</div>
          <div className="graph__label">25000</div>
          <div className="graph__label">30000</div>
          <div className="graph__label">Fans&nbsp;Reached</div>
        </div>
        <div className="graph__x">
          <div className="graph__label">July</div>
          <div className="graph__label">August</div>
          <div className="graph__label">September</div>
          <div className="graph__label">October</div>
          <div className="graph__label">November</div>
          <div className="graph__label">December</div>
        </div>
        <div>
          {
            events.map((item, i) => 
              <Link to={`/event/${item.id}`} className="events-timeline__item" style={{left: `${pos[i]}%`}} key={i}>
                <img className="events-timeline__preview" src={item.preview} alt=""/>
              </Link>
            )
          }
        </div>
      </div>
    </div>
  )
}

const Overview = ({ campaigns, segments }) => (
  <div className="container content">
    <div className="flex-between">
      <h2>Overview</h2>
      <div className="overview-total">Total fans reached <b>1,421,432</b></div>
    </div>
    <EventsTimeline events={campaigns} />
    <h2>Latest Campaigns</h2>
    <Campaigns collection={campaigns} items="4" />
    <h2>Active Segments</h2>
    <Segments segments={segments} />
  </div>
)

function mapStateToProps(state) {
  return { 
    campaigns: state.campaigns.active,
    segments: state.segments,
   }
}

export default connect(mapStateToProps)(Overview)


// WEBPACK FOOTER //
// ./src/components/Overview.js